// extracted by mini-css-extract-plugin
export default {"container":"MS7sOC","header":"E8Zofv","link":"hK3Onr","list":"AMlRJt"};